/* eslint-disable import/prefer-default-export */
export const trackLead = () => {
  if (typeof window !== "undefined" && window?.fbq) {
    window.fbq("track", "Lead")
    console.log("fbq lead")
  } else {
    console.log("fbq not loaded")
  }
}
